export const steps = [
  {
    id: 1,
    title: "Add Suppliers",
    link: true,
  },
  {
    id: 2,
    title: "Add Warehouses",
    link: true,
  },
  {
    id: 3,
    title: "Upload your Purchase orders",
    link: true,
  },
  {
    id: 4,
    title: "Add/Edit Shipment",
    link: true,
  },
];
